import { NullInjector, ReflectiveInjector } from '@zhfe/vue2-di-plugin'
import Vue from 'vue'

import { HybridBridgeService } from '@/services/hybrid-bridge.service'
import { EventBusService } from '@/services/event-bus.service'
import { HttpService } from '@/services/http.service'

export const appInjector = new ReflectiveInjector(new NullInjector(), [
  HybridBridgeService,
  {
    provide: EventBusService,
    useValue: new Vue()
  },
  HttpService
])
